import { Component } from '@angular/core';

@Component({
  selector: 'ws-site-how-it-works',
  templateUrl: './how-it-works.component.html'
})
export class SiteHowItWorksComponent {}
